import { createFileRoute } from '@tanstack/react-router';

import { legalPersonListSearch, legalPersonPendingScreen, loadPersonMessages, loadPersonScreens } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-juridicas/pendentes/')({
  validateSearch: legalPersonListSearch,
  staticData: { screen: legalPersonPendingScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'LegalPersonPendingScreen'),
});
